// extracted by mini-css-extract-plugin
var _1 = "OptionLabelWithIcon_iconButton__17967";
var _2 = "OptionLabelWithIcon_root__e345f";
export { _1 as "iconButton", _2 as "root" }
